function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "translate(14 3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M36.704.094H5.296C2.51.094.274 2.408.274 5.29V28.71c0 2.88 2.237 5.195 5.022 5.195h31.408c2.785 0 5.022-2.314 5.022-5.195V5.29c0-2.833-2.237-5.195-5.022-5.195zM39.9 28.711c0 1.842-1.415 3.306-3.196 3.306H5.296c-1.78 0-3.196-1.464-3.196-3.306V9.256h37.8V28.71zm0-21.344H2.1V5.289c0-1.842 1.415-3.306 3.196-3.306h31.408c1.78 0 3.196 1.464 3.196 3.306v2.078z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.885,
  cy: 4.722,
  className: "primary-fill",
  fill: "#434957",
  rx: 1.552,
  ry: 1.606
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.587,
  cy: 4.722,
  className: "primary-fill",
  fill: "#434957",
  rx: 1.552,
  ry: 1.606
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.335,
  cy: 4.722,
  className: "primary-fill",
  fill: "#434957",
  rx: 1.552,
  ry: 1.606
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M27.026 27.2c.183.189.411.283.64.283a.887.887 0 0 0 .638-.283l5.844-6.044a.935.935 0 0 0 0-1.323l-5.844-6.091a.863.863 0 0 0-1.278 0 .935.935 0 0 0 0 1.322l5.204 5.383-5.204 5.384a.993.993 0 0 0 0 1.369zM13.696 27.2c.182.189.41.283.639.283a.887.887 0 0 0 .639-.283.935.935 0 0 0 0-1.322l-5.204-5.43 5.204-5.337a.935.935 0 0 0 0-1.322.863.863 0 0 0-1.278 0l-5.844 5.997a.935.935 0 0 0 0 1.322l5.844 6.092z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M17.44 27.342c.136.094.273.094.41.094.32 0 .64-.189.822-.52l6.3-12.088c.228-.472.091-1.04-.365-1.275-.457-.236-1.005-.095-1.233.378l-6.3 12.136a.908.908 0 0 0 .365 1.275z"
}));

const SvgIcApi = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 38,
    viewBox: "0 0 70 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcApi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-api.9d743b52.svg";
export { ForwardRef as ReactComponent };